import styles from "@/layouts/AppLayout/HierarchyBreadcrumb.module.css";
import { multiSelectSearchPt } from "@/styles/multiSelectSearch.pt";

const panelPt = {
  ...multiSelectSearchPt,
  panel: { className: styles.panel },
  wrapper: { className: styles.wrapper },
  list: { className: styles.list },
  item: { className: styles.item },
  checkboxContainer: { className: styles.checkboxContainer },
  emptyMessage: { className: styles.emptyMessage },
};

export const pillPt = {
  root: { className: styles.pill },
  label: { className: styles.pillLabel },
  trigger: { className: styles.pillTrigger },
  clearIcon: { className: styles.pillClearIcon },
  ...panelPt,
};

export const campaignPillPt = {
  ...pillPt,
  root: { className: `${styles.pill} ${styles.campaignPill}` },
  panel: { className: `${styles.panel} ${styles.campaignPanel}` },
};
